import { QuizRowConfig } from '~/landingV4/types/quiz.types'

export const quizRows: QuizRowConfig[] = [
  {
    annotations: [],
    imageName: 'quiz-step-01-grade.png',
    imageRight: false,
    mobileImageTop: true,
    resultKey: 'v4.quiz.step1Result',
    stepNumber: '01',
    titleKey: 'v4.quiz.step1Title',
  },
  {
    annotations: [
      { position: 'top-left', textKey: 'v4.quiz.step2Annotation1' },
      { position: 'bottom-left', textKey: 'v4.quiz.step2Annotation2' },
    ],
    imageName: 'quiz-step-02-mapping.png',
    imageRight: true,
    mobileImageTop: false,
    resultKey: 'v4.quiz.step2Result',
    stepNumber: '02',
    titleKey: 'v4.quiz.step2Title',
  },
  {
    annotations: [{ position: 'bottom-right', textKey: 'v4.quiz.step3Annotation1' }],
    imageName: 'quiz-step-03-track.png',
    imageRight: false,
    mobileImageTop: false,
    resultKey: 'v4.quiz.step3Result',
    stepNumber: '03',
    titleKey: 'v4.quiz.step3Title',
  },
  {
    annotations: [
      { position: 'top-left', textKey: 'v4.quiz.step4Annotation1' },
      { position: 'bottom-left', textKey: 'v4.quiz.step4Annotation2' },
    ],
    imageName: 'quiz-step-04-video.png',
    imageRight: true,
    mobileImageTop: false,
    resultKey: 'v4.quiz.step4Result',
    stepNumber: '04',
    titleKey: 'v4.quiz.step4Title',
  },
]
